import { createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/medal.svg'
import _imports_1 from '@/assets/icons/svg/lock.svg'
import _imports_2 from '@/assets/icons/svg/checked.svg'
import _imports_3 from '@/assets/icons/svg/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-6ea89d17"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex flex-col items-start relative border h-24 mt-2 rounded-lg p-4 bg-white" }
const _hoisted_3 = { class: "flex flex-row justify-between w-full" }
const _hoisted_4 = { class: "flex self-start text-sm text-gray-550 font-playful font-semibold" }
const _hoisted_5 = { class: "flex self-end rounded-full p-1 bg-white -mt-14 mr-2" }
const _hoisted_6 = {
  key: 0,
  class: "flex rounded-full p-2 bg-teal-background"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 1,
  class: "flex rounded-full p-2 bg-gray-locked"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_1
}, null, -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "flex rounded-full p-2 bg-gray-100"
}
const _hoisted_12 = { class: "text-2xl font-playful font-semibold" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "flex flex-col w-full h-full items-start relative border mt-1 rounded-lg bg-white" }
const _hoisted_15 = { class: "flex self-end rounded-full p-1 bg-white -mt-6 mr-4" }
const _hoisted_16 = {
  key: 0,
  class: "flex rounded-full p-2 bg-teal-background"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_18 = {
  key: 1,
  class: "flex rounded-full p-2 bg-gray-locked"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_1
}, null, -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 2,
  class: "flex rounded-full p-2 bg-gray-100"
}
const _hoisted_22 = { class: "ml-4 -mt-2" }
const _hoisted_23 = { class: "w-full flex flex-row" }
const _hoisted_24 = { class: "text-sm text-gray-550 font-playful font-semibold" }
const _hoisted_25 = {
  key: 0,
  class: "w-full flex flex-row"
}
const _hoisted_26 = { class: "text-xl font-playful font-semibold" }
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "fixed flex self-start rounded-full p-1 bg-white -mt-2 -ml-2" }
const _hoisted_29 = {
  key: 0,
  class: "flex rounded-full p-2 bg-gray-locked"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_1,
  alt: "locked"
}, null, -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "flex rounded-full p-2 bg-green-highlight"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  alt: "completed",
  src: _imports_2
}, null, -1 /* HOISTED */))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "flex rounded-full p-2 bg-yellow-star"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  alt: "completed",
  src: _imports_3
}, null, -1 /* HOISTED */))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 3,
  class: "flex rounded-full p-1 bg-gray-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PulseAnimation = _resolveComponent("PulseAnimation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Top Level "),
    (_ctx.level === 0 && _ctx.data instanceof _ctx.Sett)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `div-griditem-${_ctx.index}`,
          class: "flex flex-col",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click()))
        }, [
          _createElementVNode("div", {
            class: "flex h-64 w-64 bg-no-repeat bg-black bg-cover bg-top rounded-md",
            style: _normalizeStyle(_ctx.backgroundThumbnail)
          }, null, 4 /* STYLE */),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.data.title), 1 /* TEXT */),
              _createCommentVNode(" Badge "),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.completed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createCommentVNode(" Status "),
                      _hoisted_7
                    ]))
                  : (_ctx.disabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_PulseAnimation)
                      ]))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.data.description), 1 /* TEXT */)
            ])
          ])
        ], 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Second Level "),
    (_ctx.level === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: `div-griditem-${_ctx.index}`,
          class: _normalizeClass(["flex flex-col w-64 h-64", [_ctx.disabled || _ctx.completed ? 'p-2' : 'p-0']]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.click()))
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex h-36 w-full rounded-lg rounded-b-none", _ctx.backgroundSecondLevel])
            }, null, 2 /* CLASS */),
            _createCommentVNode(" Badge "),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.completed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createCommentVNode(" Status "),
                    _hoisted_17
                  ]))
                : (_ctx.disabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_PulseAnimation)
                    ]))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.data.name), 1 /* TEXT */)
              ]),
              (_ctx.data instanceof _ctx.Sett)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.data.subtitle), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_13))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Third Level "),
    (_ctx.level && _ctx.level > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          id: `div-griditem-${_ctx.index}`,
          class: _normalizeClass(["flex flex-col h-32 w-32 items-start relative rounded-lg", _ctx.itemType]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.click()))
        }, [
          _createElementVNode("div", _hoisted_28, [
            (_ctx.disabled && !_ctx.completed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
              : (_ctx.completed && _ctx.itemType === 'picturebook')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                : (_ctx.completed && _ctx.itemType !== 'picturebook')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                  : (!_ctx.completed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_PulseAnimation, { class: "w-6 h-6" })
                      ]))
                    : _createCommentVNode("v-if", true)
          ]),
          (_ctx.itemType === 'picturebook')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "w-full h-full bg-contain bg-no-repeat m-1",
                style: _normalizeStyle({ backgroundImage: `url(${_ctx.BookImage})` })
              }, null, 4 /* STYLE */))
            : (_ctx.itemType === 'question')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "w-full h-full bg-contain rounded-full bg-white",
                  style: _normalizeStyle({ backgroundColor: _ctx.randomTaskColor })
                }, null, 4 /* STYLE */))
              : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_27))
      : _createCommentVNode("v-if", true)
  ]))
}